import { render, staticRenderFns } from "./ProcessFaq.vue?vue&type=template&id=1125f0cf&"
import script from "./ProcessFaq.vue?vue&type=script&lang=js&"
export * from "./ProcessFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports